import { render, staticRenderFns } from "./BrandFormPickup.vue?vue&type=template&id=917d2212&"
import script from "./BrandFormPickup.vue?vue&type=script&lang=js&"
export * from "./BrandFormPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports